import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (!this.element.id) throw new Error("Form must have an id attribute for localStorage namespacing");

    document.addEventListener("change", this.#onChange);
    this.element.addEventListener("input", this.save);
    this.element.addEventListener("change", this.save);
  }

  disconnect() {
    document.removeEventListener("change", this.#onChange);
    this.element.removeEventListener("input", this.save);
    this.element.removeEventListener("change", this.save);
  }

  save = () => {
    window.saveForm(this.element.id);
  };

  // Private

  #onChange = (event) => {
    if (event.target.getAttribute("form") === this.element.id) this.save();
  };
}
